import React, {useEffect} from "react";
import {
  Card, CardBody,
  CardHeader,
  CardHeaderTitle, CardHeaderToolbar,
  LoadingDialog,
  Pagination
} from "../../../../../_metronic/_partials/controls";
import { Filter } from "./Filter";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as actions from "../../_redux/actions";
import {useMetadata} from "../../../../../_emywork/AEPagination";
import {AESVG} from "../../../../../_emywork/components/svg";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {useIntl} from "react-intl";
import {AEMoment} from "../../../../../_emywork/components/moment";
import {useModuleContext} from "../../ModuleContext";
import {CONTEXT} from "../../utils/ModuleHelpers";
import {AERole} from "../../../../../_emywork/components/AERole";
import {roles} from "../../../../../index";

export function List() {
  const {openDeleteDialog, openEditPage, setOnDelete, onDelete} = useModuleContext();
  const { entities, meta, isLoading } = useSelector( state => state[CONTEXT].list, shallowEqual );
  const {formatMessage} = useIntl();
  const dispatch = useDispatch();
  const metadata = useMetadata(meta);
  const { page, perPage, sortAsc, filters, sortField, select,  setSort, setSearch, setCreatedAt, setFilters } = metadata;

  const getEntities = ()=>{
    dispatch(actions.fetchEntities(metadata.toAEMetadata()));
  }
  useEffect(() => {
    getEntities()
  }, [dispatch, page, perPage, filters, select, sortField, sortAsc]);


  const columns = [
    {name:'name_ar',title:'LANG.AR'},
    {name:'name_en',title:'LANG.EN'},
    {name:'name_fr',title:'LANG.FR'},
    {name:'name_es',title:'LANG.ES'},
    {name:'created_at',title:'CREATED_AT', type: 'date'},
    {name:'updated_at',title:'UPDATED_AT', type: 'date'},
  ]
  return (
    <>
      <LoadingDialog isLoading={isLoading} text={formatMessage({id:'LOADING'})} />
      <Card>
        <CardHeader title={formatMessage({id:'SKILLS'})}>
          <CardHeaderToolbar>
            <Filter filters={filters} setSearch={setSearch} setCreatedAt={setCreatedAt} setFilters={setFilters}/>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="table-responsive gutter-b">
            <table className="table table-head-custom table-vertical-center table-head-bg table-borderless">
              <thead>
              <tr className="text-left">
                {
                  columns.map(c=>{
                    const isSame = sortField === c.name;
                    return (
                      <th key={c.name} className='text-nowrap'>
                        <AEButton
                          variant={isSame ? 'link-primary' : null}
                          className="p-0 space"
                          onClick={() => {
                            setSort(c.name, !sortAsc)
                          }}
                          fontWeight={"bolder"}
                        >
                          {formatMessage({id:c.title})}
                          {
                            isSame &&
                            <i className={`flaticon2-arrow-${sortAsc ? 'down' : 'up'} icon-sm pl-3`} />
                            // <AESVG
                            //   path={`/Navigation/Arrow-${sortAsc ? 'down' : 'up'}.svg`}
                            //   variant={isSame ? 'primary' : ''}
                            //   size={"sm"}
                            //   className={"pl-3"}
                            // />
                          }

                        </AEButton>
                      </th>
                    )})
                }
                <th />
              </tr>
              </thead>
              <tbody>
              {
                entities.map((r)=>{
                  // const label = template ? r[name] : template(r)
                  return (
                    <tr key={r.id} className="border-bottom rounded">
                      {
                        columns.map((c)=>{
                          let label = r[c.name];
                          switch (c.type){
                            case "date": label =  (<AEMoment date={r[c.name]} format={"L"} />);
                          }
                          return ( <td key={c.name}> {label} </td>)
                        })
                      }
                      <td className={"d-flex"}>
                        {
                          <AERole accept={[roles.super_admin]} >
                            <>
                              <AEButton variant={"light"} size={"sm"} className={'mr-1'} onClick={e=>{openEditPage(r.id)}}>
                                {formatMessage({id:"EDIT"})}
                              </AEButton>
                              <AEButton variant={"light"} size={"sm"} onClick={e=>{
                                setOnDelete({...onDelete, getEntities:getEntities})
                                openDeleteDialog(r.id);

                              }}> {formatMessage({id:"DELETE"})} </AEButton>
                            </>
                          </AERole>
                        }

                      </td>
                    </tr> )
                })
              }
              {
                !isLoading && entities.length === 0 &&
                <tr className={"text-center"}>
                  <td colSpan={columns.length+1} className="font-weight-bolder"> {formatMessage({id:"LIST.EMPTY"})} </td>
                </tr>
              }
              </tbody>
            </table>
          </div>
          <Pagination {...metadata} className={''}/>

        </CardBody>
      </Card>
    </>
  );
}
